import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const AddWorker = () => {
  const [formData, setFormData] = useState({
    name: "",
    date_of_birth: "",
    address: "",
    landmark: "",
    pin_code: "",
    mobile: "",
    email: "",
    gender: "",
   
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";
  
    try {
      // api token fetch 
      const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          return;
        }

      // Save data Code 
      const response = await fetch(`${apiUrl}/add-staff`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          su_id: 1,
          api_token: apiToken,
          trans_from: "SUPER_ADMIN",
          ...formData,
        }),
      });
      if (response.ok) {
        const responseData = await response.json();
        console.log("Staff Added successfully", responseData);
        
      if (responseData.status === "success") {
        console.log("Staff Added Successfully");
        toast.success("Staff Added successfully",{ autoClose: 1000 });

        // ..........<Clear Form Feilds>.........
        const form = e.target;
        Array.from(form.elements).forEach((element) => {
          if (element.tagName === "INPUT" || element.tagName === "SELECT" || element.tagName === "TEXTAREA") {
            element.value = "";
          }
        });
        
      } else {
        console.error("Failed to Add Staff", response.statusText);

        toast.error("Failed to Add Staff", { autoClose: 1000 });
      }
       
      } else {
        console.error("Failed to Add Staff", response.statusText);
      }
    } catch (error) {
      console.error("Error occurred while Added Staff", error);
      toast.error("Error occurred while Added Staff",{ autoClose: 1000 });
    }
  };

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <h1 className="h3 mb-4 text-gray-800">Add New Worker</h1>
              <div className="card">
                <div className="card-header">Add Worker</div>
                <div className="card-body" style={{ background: "white" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Full Name</label>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              placeholder="Enter Full Name"
                              value={formData.name}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Date Of Birth</label>
                            <input
                              type="date"
                              name="date_of_birth"
                              className="form-control"
                              value={formData.date_of_birth}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Address</label>
                            <input
                              type="text"
                              name="address"
                              className="form-control"
                              placeholder="Enter Address"
                              value={formData.address}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Landmark</label>
                            <input
                              type="text"
                              name="landmark"
                              className="form-control"
                              placeholder="Enter Landmark"
                              value={formData.landmark}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Pin Code</label>
                            <input
                              type="number"
                              name="pin_code"
                              className="form-control"
                              placeholder="Enter Pin Code"
                              value={formData.pin_code}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Contact</label>
                            <input
                              type="number"
                              name="mobile"
                              className="form-control"
                              placeholder="Enter Mobile Number"
                              value={formData.mobile}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>E-Mail</label>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter Email"
                              value={formData.email}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Gender</label><br />
                            <input
                              type="radio"
                              name="gender"
                              id="male"
                              className=""
                              value="MALE"
                              onChange={handleInputChange}
                              checked={formData.gender === "MALE"}
                            /><label htmlFor="male" style={{ margin: "0px 5px" }}>Male</label>
                            <input
                              type="radio"
                              name="gender"
                              id="female"
                              className=""
                              value="FEMALE"
                              onChange={handleInputChange}
                              checked={formData.gender === "FEMALE"}
                            /><label htmlFor="female" style={{ margin: "0px 5px" }}>Female</label>
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      >
                        Add Staff
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
